// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown--P_iyS0IvXqYeJKU"};